import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Our React Native enables you to integrate PostHog with your React Native project. For React Native projects built with Expo, there are no mobile native dependencies outside of supported Expo packages.`}</p>
    <p>{`To install, add the `}<inlineCode parentName="p">{`posthog-react-native`}</inlineCode>{` package to your project as well as the required peer dependencies.`}</p>
    <h4 {...{
      "id": "expo-apps"
    }}>{`Expo apps`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npx expo install posthog-react-native expo-file-system expo-application expo-device expo-localization
`}</code></pre>
    <h4 {...{
      "id": "react-native-apps"
    }}>{`React Native apps`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add posthog-react-native @react-native-async-storage/async-storage react-native-device-info react-native-localize
# or
npm i -s posthog-react-native @react-native-async-storage/async-storage react-native-device-info react-native-localize
`}</code></pre>
    <h4 {...{
      "id": "react-native-web-and-macos"
    }}>{`React Native Web and macOS`}</h4>
    <p>{`If you're using `}<a parentName="p" {...{
        "href": "https://github.com/necolas/react-native-web"
      }}>{`React Native Web`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/microsoft/react-native-macos"
      }}>{`React Native macOS`}</a>{`, do not use the `}<a parentName="p" {...{
        "href": "https://github.com/expo/expo/tree/master/packages/expo-file-system"
      }}>{`expo-file-system`}</a>{` package since the Web and macOS targets aren't supported, use the `}<a parentName="p" {...{
        "href": "https://github.com/react-native-async-storage/async-storage"
      }}>{`@react-native-async-storage/async-storage`}</a>{` package instead.`}</p>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <h4 {...{
      "id": "with-the-posthogprovider"
    }}>{`With the PosthogProvider`}</h4>
    <p>{`The recommended way to set up PostHog for React Native is to use the `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{`. This utilizes the Context API to pass the PostHog client around, and enables `}<a parentName="p" {...{
        "href": "/docs/product-analytics/autocapture"
      }}>{`autocapture`}</a>{`.`}</p>
    <p>{`To set up `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{`, add it to your `}<inlineCode parentName="p">{`App.js`}</inlineCode>{` or `}<inlineCode parentName="p">{`App.ts`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native",
        "metastring": "file=App.js",
        "file": "App.js"
      }}>{`// App.(js|ts)
import { usePostHog, PostHogProvider } from 'posthog-react-native'
...

export function MyApp() {
    return (
        <PostHogProvider apiKey="<ph_project_api_key>" options={{
            // usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'
            host: '<ph_client_api_host>', // TIP: host is optional if you use https://us.i.posthog.com
        }}>
            <MyComponent />
        </PostHogProvider>
    )
}
`}</code></pre>
    <p>{`Then you can access PostHog using the `}<inlineCode parentName="p">{`usePostHog()`}</inlineCode>{` hook:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`const MyComponent = () => {
    const posthog = usePostHog()

    useEffect(() => {
        posthog.capture("event_name")
    }, [posthog])
}
`}</code></pre>
    <h4 {...{
      "id": "without-the-posthogprovider"
    }}>{`Without the PosthogProvider`}</h4>
    <p>{`If you prefer not to use the provider, you can initialize PostHog in its own file and import the instance from there:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native",
        "metastring": "file=posthog.ts",
        "file": "posthog.ts"
      }}>{`import PostHog from 'posthog-react-native'

export const posthog = new PostHog('<ph_project_api_key>', {
  // usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'  
  host: '<ph_client_api_host>' // TIP: host is optional if you use https://us.i.posthog.com
})
`}</code></pre>
    <p>{`Then you can access PostHog by importing your instance:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`import { posthog } from './posthog'

export function MyApp1() {
    useEffect(async () => {
        posthog.capture('event_name')
    }, [posthog])

    return <View>Your app code</View>
}
`}</code></pre>
    <p>{`You can even use this instance with the PostHogProvider:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`import { posthog } from './posthog'

export function MyApp() {
  return <PostHogProvider client={posthog}>{/* Your app code */}</PostHogProvider>
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      